export default __webpack_public_path__ + "static/Team_Member_SIMON-af26ce8ebaaa3f6644d8a7a2abe6ee6b.png";